export const FORM_FIELD_CITY_ID = "city_id";
export const FORM_FIELD_DAMAGE_DETAILS = "damage_details";
export const FORM_FIELD_SERVICE_CENTRE_ID = "service_centre_id";
export const FORM_FIELD_STATE_ID = "state_id";
export const FORM_FIELD_PREFERRED_DATE = "preferred_date";
export const FORM_FIELD_PREFERRED_TIMESLOT = "preferred_timeslot";

export const ONLY_ALPHA_NUMERIC_FIELDS = [];
export const ONLY_ALPHA_NUMERIC_SPACE_FIELDS = [];
export const ONLY_DIGIT_FIELDS = [];

export const FIELDS_HAVING_ALPHABET_AND_SPACE_ONLY = [];
export const FIXED_LENGTH_FIELDS = [];

export const RESPONSE_FIELDS = [];
export const RESPONSE_FIELDS_DATE = [];
export const DAMAGE_DETAIL_MIN_CHAR_LENGTH = 60;
